import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import { SITE } from "@/data/site";
import { Logo } from "@/components/layout/Header";

const COLS = [
  ["Company", [["About", "/about"], ["Our Process", "/how-we-build"], ["Work", "/work"], ["Careers", "/careers"], ["FAQ", "/faq"]]],
  ["Explore", [["Ventures", "/ventures"], ["Services", "/services"], ["Venture Partnerships", "/venture-partnerships"], ["Insights", "/insights"], ["Engagement Models", "/engagement-models"]]],
  ["Services", [["MVP Development", "/services/mvp-development"], ["AI Engineering", "/services/ai-engineering"], ["Fractional CTO", "/services/fractional-cto"], ["Architecture & Cloud", "/services/architecture-cloud"]]],
];

export default function Footer() {
  return (
    <footer className="relative border-t border-si-line bg-[#03060f]" data-testid="site-footer">
      <div className="wrap pb-10 pt-20">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo className="h-11" />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-si-muted">{SITE.statement}</p>
            <p className="mt-6 text-sm font-semibold text-fusion">{SITE.tagline}</p>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8">
            {COLS.map(([title, links]) => (
              <div key={title}>
                <p className="eyebrow mb-5 !text-si-muted">{title}</p>
                <ul className="space-y-3">
                  {links.map(([l, to]) => (
                    <li key={to}><Link to={to} className="text-[15px] text-si-text/90 transition-colors hover:text-si-cyan" data-testid={`footer-link-${to.replace(/\//g, "-").slice(1)}`}>{l}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
            <div>
              <p className="eyebrow mb-5 !text-si-muted">Connect</p>
              <ul className="space-y-3">
                <li><Link to="/contact" className="text-[15px] text-si-text/90 hover:text-si-cyan" data-testid="footer-link-contact">Contact</Link></li>
                <li><a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[15px] text-si-text/90 hover:text-si-cyan" data-testid="footer-linkedin"><Linkedin className="h-4 w-4" />LinkedIn</a></li>
                <li><a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 text-[15px] text-si-text/90 hover:text-si-cyan" data-testid="footer-email"><Mail className="h-4 w-4" />{SITE.email}</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-20 select-none overflow-hidden" aria-hidden="true">
          <p className="whitespace-nowrap text-[clamp(3rem,13vw,12rem)] font-extrabold leading-none tracking-[-0.05em] text-transparent [-webkit-text-stroke:1px_#243149]">Spark to scale.</p>
        </div>
        <div className="mt-8 flex flex-col gap-4 border-t border-si-line pt-8 text-sm text-si-muted sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} SparkIdea Interactive. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-si-text" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-si-text" data-testid="footer-terms">Terms of Service</Link>
            <Link to="/cookies" className="hover:text-si-text" data-testid="footer-cookies">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
